export default __webpack_public_path__ + "static/noissue-team-badge-9f2484f95b8f8d4d5978eeba82adee74.svg";